// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"353":"contact","594":"about","608":"Impressum","652":"service","838":"Disclaimer","993":"home-one"}[chunkId] + "." + {"353":"e568f3c6","594":"e568f3c6","608":"e568f3c6","652":"e568f3c6","838":"e568f3c6","993":"e568f3c6"}[chunkId] + ".css";
};